export class ProductInformation {
  constructor() {}

  imageSource: string;
  manufacturer: string;
  name: string;
  uniqueSellingPoints: string[];
  additionalInformationUrl: string;
}

export enum EquipmentVariant {
  MobilePhone = 'MobilePhone',
  Accessory = 'Accessory',
}
